import { render } from "./vipManage.vue?vue&type=template&id=f4187724&scoped=true&ts=true"
import script from "./vipManage.vue?vue&type=script&lang=ts"
export * from "./vipManage.vue?vue&type=script&lang=ts"

import "./vipManage.vue?vue&type=style&index=0&id=f4187724&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4187724"]])

export default __exports__